import { render } from "./ArrowIcon.vue?vue&type=template&id=113dcd57"
import script from "./ArrowIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrowIcon.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/widgets/ArrowIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "113dcd57"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('113dcd57', __exports__)) {
    api.reload('113dcd57', __exports__)
  }
  
  module.hot.accept("./ArrowIcon.vue?vue&type=template&id=113dcd57", () => {
    api.rerender('113dcd57', render)
  })

}


export default __exports__